import { useAppContext } from "@qpr/client-api-base/context/AppCtxProvider";
import defaultAttributes from "backend/defaultAttributes";
import flattenHierarchy from "backend/flattenHierarchy";
import { usePeriod } from "backend/model/usePeriod";
import { getChildHierarchy } from "backend/model/getChildHierarchy";
import { resultSort } from "init/sort";
import React from "react";
import { useQuery } from "react-query";
import usePeriodLevels from "../model/usePeriodLevels";
import usePeriodFromString from "../model/usePeriodFromString";

const useFlatHierarchy = (
  id?: string,
  depthParam?: number,
  period?: string
) => {
  const depth = depthParam || 10;
  const ctx = useAppContext();

  const currentPeriod = usePeriodFromString(period);
  const { data: periodLevels } = usePeriodLevels();

  return useQuery(
    `data-flat-children-${id}-${ctx.period}-${depth}`,
    () =>
      getChildHierarchy(
        id || "",
        (q) =>
          q.attributes(
            ...defaultAttributes(currentPeriod?.name, periodLevels!!)
          ),
        depth || 10,
        currentPeriod!,
        periodLevels!
      ).then((list) => resultSort(flattenHierarchy(list))),
    {
      enabled: !!id && !!currentPeriod && !!periodLevels,
      cacheTime: 10 * (60 * 1000),
      staleTime: 10 * (60 * 1000),
    }
  );
};

export default useFlatHierarchy;
